module.exports = __webpack_public_path__ + "img/huevo.54c59498.svg";